<template>
  <div class="login-page-box">
    <div class="form-box">
      <img src="@/assets/logo2.png" alt="" />
      <span class="title">财经大数据中心</span>
      <div class="form">
        <el-input
          class="login-input"
          placeholder="请输入账号"
          maxlength="20"
          v-model.trim="formData.account"
        >
          <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
          <template #prefix>
            <img src="@/assets/zhanghao.png" class="prefix" alt="" />
          </template>
        </el-input>
        <el-input
          class="login-input"
          maxlength="20"
          show-password
          placeholder="请输入密码"
          v-model.trim="formData.password"
          >0.1
          <template #prefix>
            <img
              src="@/assets/zhanghaoanquan.png"
              class="prefix"
              style="margin-left: 2px;"
              alt=""
            />
          </template>
        </el-input>
      </div>

      <el-button type="primary" @click="login">登 录</el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      isToggleTheme: ["isToggleTheme"]
    })
  },
  data() {
    return {
      formData: {
        account: "",
        password: ""
      }
    };
  },
  mounted() {
    this.$nextTick(() => {
      console.log('created - 路由参数:', this.$route.query);
      this.init();// 初始化跳转参数
    });
  },
  methods: {
    async init() {
      let token = {
        data: {
          accessToken: sessionStorage.getItem("AccessToken")
        }
      };
      
      // 添加调试信息
      // console.log('window.location.search:', window.location.search);
      // console.log('window.location.hash:', window.location.hash);
      // console.log('this.$route.query:', this.$route.query);
      
      // 尝试从search中解析参数（参数在hash前面的情况）
      let userId, loginType,theme;
      
      // 1. 首先从window.location.search中解析参数
      if (window.location.search) {
        const params = new URLSearchParams(window.location.search);
        userId = params.get('userId');
        loginType = params.get('loginType');
        theme = params.get('theme');
        console.log('从search中解析的参数:', { userId, loginType,theme });
      }
      
      // 2. 如果search中没有，再从hash中解析参数
      if (!userId) {
        const hash = window.location.hash;
        const queryString = hash.split('?')[1];
        if (queryString) {
          const params = new URLSearchParams(queryString);
          userId = params.get('userId');
          loginType = params.get('loginType');
          theme = params.get('theme');
          console.log('从hash中解析的参数:', { userId, loginType,theme });
        }
      }
      
      // 3. 最后尝试从this.$route.query中获取
      if (!userId) {
        userId = this.$route.query.userId;
        loginType = this.$route.query.loginType;
        theme = this.$route.query.theme;
        console.log('从this.$route.query中解析的参数:', { userId, loginType,theme });
      }
      
      if (userId) {
        try {
          token = await this.GetToken({
            loginType: loginType || 0,
            id: userId
          });
          let data = token.data;
          let userInfo = this.$jwt.decode(data.access_token || data.accessToken);
          let userobj = {
            accessToken: data.access_token || data.accessToken,
            id: userInfo.id,
            mobilePhone: userInfo.phone_number,
            realName: userInfo.realName,
            photo: userInfo.photo,
            type: userInfo.userType,
            tenantId: userInfo.tenantId,
            logintype: "oldLogin",
            schoolName: userInfo.schoolName,
            schoolType: userInfo.schoolType,
            isVip: userInfo.isVip //是否是vip
          };
          this.$store.commit("userInfo", userobj);
          this.$router.push("/");
        } catch (error) {
          console.error('获取token失败:', error);
        }
      } else if (!sessionStorage.getItem("AccessToken")) {
        // 已经在登录页面，不需要再跳转
        return;
      }
    },
    // 添加GetToken方法
    GetToken(params) {
      return new Promise((resolve, reject) => {
        this.$Api.GetToken(params).then(res => {
          resolve(res);
        }).catch(err => {
          reject(err);
        });
      });
    },
    async login() {
      let token = await this.$Api.userAuthentication({
        logintype: 0,
        password: this.formData.password,
        userName: this.formData.account
      });
      console.log(token);
      if (token.code == 200) {
        // sessionStorage.setItem('tokenName',token.data.access_token)
        let data = token.data;
        let userInfo = this.$jwt.decode(data.access_token || data.accessToken);
        let userobj = {
          accessToken: data.access_token || data.accessToken,
          id: userInfo.id,
          mobilePhone: userInfo.phone_number,
          realName: userInfo.realName,
          photo: userInfo.photo,
          type: userInfo.userType,
          tenantId: userInfo.tenantId,
          logintype: "oldLogin",
          schoolName: userInfo.schoolName,
          schoolType: userInfo.schoolType,
          isVip: userInfo.isVip //是否是vip
        };
        this.$store.commit("userInfo", userobj);
        this.$router.push("/");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.login-page-box {
  width: 100vw;
  height: 100vh;
  background: url("../../assets/Login-background.png") no-repeat center;
  box-sizing: border-box;
  background-size: 100% 100%;
  padding-top: 212px;
  .form-box {
    width: 446px;
    height: 492px;
    background: url("../../assets/login-form.png") no-repeat center;
    background-size: 100% 100%;
    margin: auto;
    box-sizing: border-box;
    padding: 40px 40px 0px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    > img {
      width: 70px;
      height: 70px;
    }
    .title {
      color: white;
      font-size: 20px;
      margin-top: 15px;
      margin-bottom: 30px;
    }
    .form {
      .login-input {
        margin-bottom: 20px;
        /deep/.el-input__inner {
          background-color: #121193 !important;
          border: none;
          color: rgb(227, 239, 250);
          padding-left: 50px;
        }
        /deep/.prefix {
          position: absolute;
          left: 10px;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    .el-button {
      width: 100%;
      background-color: #0973f1;
      border-color: #0973f1;
      margin-top: 40px;
      &:hover {
        background-color: #1c7ef5;
        border-color: #1c7ef5;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue